var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CabeceraModal',{attrs:{"titulo":"Ver Configuración de Autorización"},on:{"cerrar":function($event){return _vm.$emit('cerrarVer')}}},[_c('div',{staticClass:"cabecera"})])}
var staticRenderFns = []

export { render, staticRenderFns }